import { hide } from '@floating-ui/dom';
import { defineStore } from 'pinia';

export const usePaginationStore = defineStore('pagination', {
  state: () => ({
    itemsPerPage: 10,
  }),
  actions: {
  },
});